import { ActionType } from "../action-types/type";
import { AuthAction } from "../actions";

const initialState = { message: "" };

export function messageReducer(state = initialState, action: AuthAction) {
  switch (action.type) {
    case ActionType.SET_MESSAGE:
      return { message: action.payload };
    case ActionType.CLEAR_MESSAGE:
      return { message: "" };
    default:
      return state;
  }
}
